import { Routes, RouterModule } from '@angular/router';
import { AccountTodosLayoutComponent } from './layout/account-todos-layout.component';
import { AccountTodosDashboardComponent } from './dashboard/account-todos-dashboard.component';
import { AccountTodosAllComponent } from './all/account-todos-all.component';

const accountTodosRoutes: Routes = [
  // Account routes
  {
    path: '',
    component: AccountTodosLayoutComponent,
    children: [
      {
        path: '',
        component: AccountTodosAllComponent,
      },
      { path: 'dashboard', component: AccountTodosDashboardComponent },
    ],
  },
];

export const AccountTodosRouting = RouterModule.forChild(
  accountTodosRoutes,
);
